import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11e9027a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nova", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = { class: "ss-tela-conteudo" }
const _hoisted_9 = { class: "ss-card ss-card-space" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS")
], -1))
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Filtrar", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_selecionar_estoque = _resolveComponent("selecionar-estoque")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_tipo_produto = _resolveComponent("selecionar-tipo-produto")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_transferencia_estoque_modal = _resolveComponent("transferencia-estoque-modal")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: "TRANSFERENCIA_ENTRE_ESTOQUES",
          tituloRecurso: "Transferências entre Estoques",
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas,
          "onUpdate:empresasSelecionadas": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
        }, {
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-primary ss-btn-tela",
              style: {"margin-right":"10px"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.apresentarModalTransferencia=true))
            }, _hoisted_5)
          ]),
          _: 1
        }, 8, ["empresasSelecionadas"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_selecionar_empresa, {
                  codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                  "onUpdate:codigosSelecionados": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event)),
                  varias: true,
                  onChange: _ctx.atualizarSelecaoEmpresas
                }, null, 8, ["codigosSelecionados", "onChange"])
              ])
            ]),
            _createVNode(_component_a_form, {
              class: "ss-alinhar-texto-esquerda",
              layout: "vertical"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_card, { titulo: "FILTROS" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_a_form_item, {
                              label: "Estoques",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_estoque, {
                                  varios: true,
                                  codigosSelecionados: _ctx.state.parametrosConsulta.estoques,
                                  "onUpdate:codigosSelecionados": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.parametrosConsulta.estoques) = $event)),
                                  empresas: _ctx.telaBase.empresasSelecionadas
                                }, null, 8, ["codigosSelecionados", "empresas"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_a_form_item, {
                              label: "Usuários",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_usuario, {
                                  codigosSelecionados: _ctx.state.parametrosConsulta.usuarios,
                                  "onUpdate:codigosSelecionados": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.parametrosConsulta.usuarios) = $event)),
                                  varios: true,
                                  empresas: _ctx.telaBase.empresasSelecionadas,
                                  onChange: _ctx.limparInformacoesBusca
                                }, null, 8, ["codigosSelecionados", "empresas", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_a_form_item, {
                              label: "Período",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data_inicial_final, {
                                  dataInicialSelecionada: _ctx.state.parametrosConsulta.dataInicial,
                                  "onUpdate:dataInicialSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.parametrosConsulta.dataInicial) = $event)),
                                  dataFinalSelecionada: _ctx.state.parametrosConsulta.dataFinal,
                                  "onUpdate:dataFinalSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.parametrosConsulta.dataFinal) = $event))
                                }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_a_form_item, {
                              label: "Produtos",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_produto, {
                                  codigosSelecionados: _ctx.state.parametrosConsulta.codigosProdutosDefinicoes,
                                  "onUpdate:codigosSelecionados": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.parametrosConsulta.codigosProdutosDefinicoes) = $event)),
                                  varios: true,
                                  modoDefinicaoProduto: true,
                                  empresas: _ctx.telaBase.empresasSelecionadas,
                                  apresentarCodigoInterno: true,
                                  placeholder: 'Digite o código interno, código de barras, código personalizado ou descrição do produto...',
                                  limparSelecao: false,
                                  onChange: _ctx.limparInformacoesBusca
                                }, null, 8, ["codigosSelecionados", "empresas", "placeholder", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_a_form_item, {
                              label: "Tipos de Produtos",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_produto, {
                                  codigosSelecionados: _ctx.state.parametrosConsulta.tiposProdutos,
                                  "onUpdate:codigosSelecionados": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.parametrosConsulta.tiposProdutos) = $event)),
                                  varios: true,
                                  placeholder: "Todos",
                                  limparSelecao: false,
                                  onChange: _ctx.limparInformacoesBusca
                                }, null, 8, ["codigosSelecionados", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_a_form_item, {
                              label: " ",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ant-btn ant-btn-primary ant-btn-block",
                                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.buscarMovimentacoes && _ctx.buscarMovimentacoes(...args)))
                                }, _hoisted_24)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card, { titulo: "TRANSFERÊNCIAS" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_a_table, {
                          key: _ctx.state.controleResultado,
                          columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                          "data-source": _ctx.state.transferencias,
                          rowKey: "codigo",
                          pagination: false,
                          scroll: { x: 1500 },
                          loading: _ctx.gradeBase.buscandoDados,
                          size: "small"
                        }, {
                          bodyCell: _withCtx(({ column, record }) => [
                            (column.key === 'Quantidade')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, record.casasDecimais)), 1))
                              : (column.key === 'DataHora')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(record.data)), 1))
                                : _createCommentVNode("", true)
                          ]),
                          emptyText: _withCtx(() => [
                            _createVNode(_component_mensagem_sem_dados, {
                              resultadoPesquisa: true,
                              mensagem: _ctx.preparaMensagemGrade()
                            }, null, 8, ["mensagem"])
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source", "loading"]))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_transferencia_estoque_modal, {
                  visivel: _ctx.state.apresentarModalTransferencia,
                  "onUpdate:visivel": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.apresentarModalTransferencia) = $event))
                }, null, 8, ["visivel"])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}